import $ from "jquery";
import videojs from "video.js";
import BD_Component from "@bd-core/bd-component";
import compile from "@bd-utils/handlerbars-helper";
import CONFIG from "@bd-core/config";
import { getState } from "@bd-stores/store";
import {
    getRoomStatus,
    getFinalTeamAnswers,
} from "@bd-stores/game-progress";
import { getRoomAnswerById } from "@bd-stores/game-data";
import CompletionPopup from "@bd-utils/completion-popup";
import {
    maybeUpdateRoomStatus,
    updateFinalRoomAnswer,
    getFinalRoomAnswers,
    setMiddleState,
    updateRoomAnswer,
    getRoomAnswers
} from "@bd-core/firebase-actions";

export class RoomCluesEquations extends BD_Component {
    constructor() {
        super();

        this.id = "clues_equations";
        this.templateID = "clues_equations-template";

        this.elms = {
            equationItem: ".js-equation-item",
            questionItem: ".js-question-item",
            closeBtn: ".js-cluesEquations-close",
            inputAnswer: ".js-input-answer",
            checkAnswer: ".js-check-button",
            background: ".js-screen-img",
            shareBtn: ".js-share-btn",
            openSourceDOM: ".js-update-sourcedrop",
            sourceitem: ".js-sourcedrop",
            sourceSelector: ".js-sourcedrop-selector",
            sourceSelect: ".js-select-source",
            sourcePreview: ".js-source-item",
            sourcePlaceholder: ".js-source-placeholder",
            removeSource: ".js-remove-sourcedrop",
            statement: ".js-statement",
            question: ".js-question",
            publishBtn: ".js-publish"
        };

        this._events = this.getEvents();

        this.userAnswer = undefined;

        this.completionPopup = new CompletionPopup();
    }

    /**
     * @returns {Array<BD_ComponentEvent>}
     */
    getEvents() {
        const elms = this.elms;
        return [
            // {
            //     event: "keypress",
            //     selector: elms.statement,
            //     handler: this.inputAnswer,
            // },
            {
                event: "click",
                selector: elms.publishBtn,
                handler: this.checkStatement,
            },
            {
                event: "click",
                selector: elms.openSourceDOM,
                handler: this.onToggleSource,
            },
            {
                event: "click",
                selector: elms.sourceSelect,
                handler: this.onSelectSource,
            },
            {
                event: "click",
                selector: elms.removeSource,
                handler: this.onRemoveSource,
            },
        ];
    }

    beforeInit() {
        this.render();
        this.setGameState();
        this.playIntroVideo();
    }

    getModifiedData() {
        const modifiedData = { ...this._data };
        const hotspots = modifiedData["hotspots"];

        const _questions = this._data.questions.map((q, i) => {
            if (hotspots.length < 1) return q;

            if (hotspots[i]["hotspot_type"] === "puzzle") {
                let hotspot = { ...hotspots[i] };
                return {
                    ...q,
                    position_top: hotspot["position_top"],
                    position_left: hotspot["position_left"],
                };
            }
        });

        const hintHotspots = hotspots.filter(
            (hotspot) => hotspot["hotspot_type"] === "hint",
        );

        const hotspotCount = hintHotspots.length;
        const defaultValue = "50%";
        const _hints = this._data.hints.map((hint, i) => {
            const font_fam = hint.hint_font_family.split("|");
            const font_name = font_fam[0];
            const font_category = font_fam[1];

            return {
                ...hint,
                font_family: `"${font_name}", ${font_category}`,
                has_image: hint.image,
                position_top:
                    hotspotCount > 0 && hintHotspots[i]
                        ? hintHotspots[i].position_top
                        : defaultValue,
                position_left:
                    hotspotCount > 0 && hintHotspots[i]
                        ? hintHotspots[i].position_left
                        : defaultValue,
            };
        });


        const modified = {
            ...modifiedData,
            questions: _questions,
            hints: _hints,
        };

        return modified;
    }

    render() {
        const data = this.getModifiedData();

        const htmlTemplate = $("#" + this.templateID).html();
        const html = compile(htmlTemplate, data);
        $(".app").html(html);
    }

    onToggleSource(e, el) {        
        
        const $el = $(el);
        const elms = this.elms;

        const hasOpen = $el.parents(elms.sourceitem).hasClass("is-open");
        const isOpen = !hasOpen;

        $el.parents(elms.sourceitem).toggleClass("is-open", isOpen);
    }

    onSelectSource(e, el) {           
        
        const $el = $(el);
        const elms = this.elms;
        const $clonepreview = $el.parents(elms.sourcePreview).clone();
        const $placeholder = $el.parents(elms.sourceitem).find(".js-source-placeholder");

        $placeholder.empty();
        $clonepreview.prependTo($placeholder);
        $(".js-source-item").removeClass("is-selected");
        $el.parents(elms.sourcePreview).addClass("is-selected");
        $el.parents(elms.sourceitem).removeClass("is-open").addClass("is-filled");
    }

    onRemoveSource(e, el) {
        const $el = $(el);
        const elms = this.elms;
        const $placeholder = $el.parents(elms.sourceitem).find(".js-source-placeholder");
        const $question = $el.parents(elms.question);

        $question.removeClass(
            "is-incorrect-statement is-correct-statement is-incorrect-source is-correct-source");
        
        $(".js-select-source").prop('checked', false);
        $(".js-source-item").removeClass("is-selected");
        $placeholder.empty();
        $el.parents(elms.sourceitem).removeClass("is-filled");
    }

    onForceOppenChallenge() {}

    setGameState() {
        const roomId = this.roomId;
        const thisRoomStatus = getRoomStatus(roomId);

        /**
         * @type {BD_RoomCluesEquationsFinalAnswer}
         */
        const teamAnswers = getFinalTeamAnswers(roomId);

        // const roomAnswers = getRoomAnswerById(roomId);
        // const self = this;
        // const elms = self.elms;

        const possibleStatuses = [
            "is-status-open",
            "is-status-started",
            "is-status-completed",
        ];

        if (thisRoomStatus) {
            const $status = $(".js-room-status");
            $status.removeClass(possibleStatuses);
            $status.addClass(thisRoomStatus);
        }

        if (teamAnswers) {
            //

            if (thisRoomStatus == "is-status-completed") {
                $(".app__page").addClass("is-room-completed");
            }
        }
    }

    playIntroVideo() {
        const $introVideo = $(".videobox");
        const { intro_video } = this._data;

        if (!$introVideo.length) return;

        /**
         * check wheiter the video has url or not
         * if no url, close video popup
         **/
        if (!intro_video) {
            $introVideo.removeClass("is-open");
            return false;
        }

        const introVideo = videojs("intro-video", {
            controls: true,
            autoplay: true,
            preload: "auto",
            sources: [
                {
                    src: intro_video,
                    type: "video/mp4",
                },
            ],
            techOrder: ["html5"],
        });

        // handle on ended video
        introVideo.on("ended", () => {
            $introVideo.removeClass("is-open");
            introVideo.dispose();
        });

        // handle on error video
        introVideo.on("error", function () {
            $introVideo.removeClass("is-open");
            console.error("Can't play the video");
        });

        $introVideo.addClass("is-open");

        try {
            introVideo.play().catch((error) => {
                // Autoplay was blocked. Do something
                console.error("Unable to start auto play", error);
            });
        } catch (error) {
            console.error(error);
        }
    }

    // ============================== CUSTOM FUNCTION

    inputAnswer(e, el) {
        e.preventDefault();

        const $el = $(el);
        const elms = this.elms;
        const $questionWrapper = $el.parents(elms.question);

        $questionWrapper.removeClass(
            "is-incorrect-statement is-correct-statement is-incorrect-source is-correct-source");

        // const value = String($el.val(e.key));
        // this.toggleCheckButton();
    }

    toggleCheckButton() {
        const elms = this.elms;
        const $checkBtn = $(elms.checkAnswer);
        const $answers = $(elms.inputAnswer);
        let isAllAnswered = true;

        $.each($answers, function (index, elAnswer) {
            const answer = String($(elAnswer).val());
            if (answer.trim() == "") {
                isAllAnswered = false;
                return false;
            }
        });

        return $checkBtn
            .prop("disabled", !isAllAnswered)
            .toggleClass("valid", isAllAnswered);
    }

    checkStatement() {
        const elms = this.elms;
        const roomID = this.roomId;
        const { questions } = this._data;
        const correctSources = getRoomAnswerById(roomID);

        const $statements = $(elms.statement);

        $.each($statements, function (index, item) {
            const $question = $(item).parents(".js-question");
            const questionID = $question.attr("data-id");
            const questionData = questions.find(
                (item) => item.question_id === questionID,
            );
            const { 
                keyword_scoring, 
                minimum_score_treshold, 
                incorrect_statement_feedback,
                incorrect_source_feedback 
            } = questionData;

            const $sourcePlaceholder = $(item).parent().find(".js-source-placeholder");
            const $selectedSource = $sourcePlaceholder.find(".js-source-item");
            const selectedSourceId = $selectedSource.find(".js-select-source").val();

            let statementTxt = String($(item).val()).toLocaleLowerCase();
            statementTxt = statementTxt.replace(",", "");
            statementTxt = statementTxt.replace(".", "");

            const theStatementTxt = statementTxt.split(/\s+/);
            let totalScore = 0;

            keyword_scoring.forEach((value) => {
                const { word, score } = value;

                if (theStatementTxt.includes(word)) {
                    totalScore += Number(score);
                }
            });

            $question.removeClass(
            "is-incorrect-statement is-correct-statement is-incorrect-source is-correct-source");

            if (totalScore < minimum_score_treshold) {
                let incorrectFeedbackTxt = "";

                incorrect_statement_feedback.forEach((value) => {
                    const { maximal_score, minimal_score, text } = value;

                    if (
                        totalScore >= minimal_score &&
                        totalScore <= maximal_score
                    ) {
                        return (incorrectFeedbackTxt = text);
                    }
                });

                // need to handle feedback text after got incorrect state
                $question.find(".js-feedback-statement").html(incorrectFeedbackTxt);
                $question.addClass("is-incorrect-statement");
            } else {
                $question.addClass("is-correct-statement");
            }

            const correctSource = correctSources?.[questionID] || [];
            if( correctSource.includes(selectedSourceId)) {
                $question.addClass("is-correct-source");
            } else {
                $question.find(".js-feedback-source").html(incorrect_source_feedback);
                $question.addClass("is-incorrect-source");
            }
        });

        maybeUpdateRoomStatus(roomID, "is-status-started");
        this.maybeAllAnswersCorrect();
    }

    maybeAllAnswersCorrect() {
        const elms = this.elms;
        const roomID = this.roomId;
        const roomAnswers = getRoomAnswerById(roomID);
        const totalRoomAnswers = Object.keys(roomAnswers).length;
        const $question = $(elms.question);
        const totalCorrectStatement = $(`${elms.question}.is-correct-statement`).length;
        const totalCorrectSource = $(`${elms.question}.is-correct-source`).length;

        if((totalCorrectStatement === totalRoomAnswers) 
            && (totalCorrectSource === totalRoomAnswers)) 
        {
            $.each($question, function(index, item) {
                const questionID = $(item).attr("data-id");
                const $statement = $(item).find(elms.statement);
                const statementTxt = $statement.val();

                const $sourcePlaceholder = $(item).find(".js-source-placeholder");
                const $selectedSource = $sourcePlaceholder.find(".js-source-item");
                const selectedSourceId = $selectedSource.find(".js-select-source").attr("id");
                
                const userAnswer = {
                    [questionID]: {
                        statement: statementTxt,
                        source: selectedSourceId
                    }
                };

                const onSuccessUpdate = () => {
                    maybeUpdateRoomStatus(roomID, "is-status-completed");
                };

                const onErrorUpdate = () => {};

                updateFinalRoomAnswer(roomID, userAnswer)
                .then(onSuccessUpdate)
                .catch(onErrorUpdate);
            });
        }
    }

    checkAnswer(e, el) {
        const $el = $(el);
        const elms = this.elms;

        if ($el.hasClass("is-loading") || $el.hasClass("is-completed")) return;

        const $questionWrapper = $el.parents(elms.questionItem).first();
        const questionId = $questionWrapper.attr("data-id");
        const $equationItem = $(
            elms.equationItem.concat(`[data-id="${questionId}"]`),
        );
        const $answers = $questionWrapper.find(elms.inputAnswer);

        $el.addClass("is-loading").prop("disabled", true);
        $questionWrapper.removeClass("is-wrong is-completed is-middle");

        const roomId = this.roomId;
        const roomAnswers = getRoomAnswerById(roomId);

        let roomStatus = "is-status-started";
        let isMiddleState = false;
        let isCorrect = false;
        let playerAnswer = "";
        const isUsingMiddleState = this._data.isUseMiddleState;

        $.each($answers, function (index, answer) {
            const $answer = $(answer);
            playerAnswer += $answer.val();
        });

        const correctAnswer = roomAnswers?.[questionId]?.correct || false;
        const middleAnswer = roomAnswers?.[questionId]?.middle || false;

        playerAnswer = playerAnswer.toLowerCase();

        if (playerAnswer === correctAnswer) {
            isCorrect = true;
        } else if (isUsingMiddleState && playerAnswer === middleAnswer) {
            isCorrect = true;
            isMiddleState = true;
        }

        const updateData = {
            [questionId]: {
                answer: playerAnswer,
                isMiddleState: isMiddleState,
            },
        };

        if (isCorrect) {
            $questionWrapper.removeClass("is-wrong").addClass("is-completed");
            if (isMiddleState) $questionWrapper.addClass("is-middle");

            $answers.prop("readonly", true);

            $el.removeClass("is-loading valid");
            $equationItem.addClass("is-completed");

            maybeUpdateRoomStatus(roomId, roomStatus);

            const onSuccessUpdate = () => {
                if (isMiddleState) {
                    $questionWrapper.addClass("is-middle");
                    setMiddleState(roomId);
                }

                $questionWrapper.removeClass("is-wrong");
                $questionWrapper.addClass("is-completed");
                $equationItem.addClass("is-completed");
                $answers.prop("readonly", true);

                this.maybeRoomIsFinish.call(this);
            };

            const onErrorUpdate = () => {};

            updateFinalRoomAnswer(roomId, updateData)
                .then(onSuccessUpdate)
                .catch(onErrorUpdate);

            $el.removeClass("is-loading valid");
        } else {
            $questionWrapper.addClass("is-wrong");
            $el.removeClass("is-loading").removeAttr("disabled");

            maybeUpdateRoomStatus(roomId, roomStatus);
        }

        this.userAnswer = {
            [questionId]: {
                ...updateData[questionId],
                isCorrect: isCorrect,
            },
        };

        this.updateUserAnswer();
    }

    maybeRoomIsFinish() {
        const roomId = this.roomId;
        getFinalRoomAnswers(roomId).then((data) => {
            const roomAnswers = getRoomAnswerById(roomId);
            const fbRoomAnswers = data.val();

            if (
                !fbRoomAnswers ||
                typeof roomAnswers !== "object" ||
                typeof fbRoomAnswers !== "object"
            ) {
                return;
            }

            if (
                Object.keys(roomAnswers).length ==
                Object.keys(fbRoomAnswers).length
            ) {
                maybeUpdateRoomStatus(roomId, "is-status-completed");
            }
        });
    }

    updateUserAnswer() {
        const roomId = this.roomId;
        const currentPlayerId = CONFIG.user.id;

        getRoomAnswers(roomId).then((data) => {
            const fbRoomAnswers = data.val() ?? {};
            const answer = this.userAnswer;

            const userAnswer = fbRoomAnswers[currentPlayerId]?.choice;
            const answerData = { ...userAnswer, ...answer };

            updateRoomAnswer(roomId, {
                [currentPlayerId]: {
                    user_id: currentPlayerId,
                    choice: answerData,
                },
            });
        });
    }

    updateUserChoicesList(answer) {
        if ($("#locationInfo-item").length < 1) return;

        const fbRoomAnswers = answer.val() ?? {};
        const players = getState().gameProgress.players;
        const template = $("#locationInfo-item").html();

        // Filter the player to not include the current user
        const onlinePlayers = players.filter(
            (player) => player.isOnline && player.userId !== CONFIG.user.id,
        );

        $(".userChoice_list").each(function () {
            const $context = $(this).parents(".js-userChoices-context");
            const hasContext = $context.length > 0;

            const questionID = hasContext
                ? $context.attr("data-question-id")
                : undefined;

            const users = onlinePlayers.filter((player) => {
                //console.log('player', player)
                const usrID = player.userId;
                const thisPlayerAnswer = fbRoomAnswers[usrID]?.choice;

                if (typeof thisPlayerAnswer !== "object") {
                    return;
                }

                if (thisPlayerAnswer[questionID]) {
                    const answer = thisPlayerAnswer[questionID].answer;
                    const user = {
                        ...player,
                        answer: answer,
                    };

                    return user;
                }
            });

            const html = compile(template, { players: users });
            $(this).html(html);
        });
    }
}
